import { useTheme } from '@tanium/react-theme-context';
import { Theme } from '@tanium/theme-data';

export type ThemeDefinition<T = string> = (theme: Theme) => T;

/**
 * Hook that passes theme to specified theme definition
 */
export function useThemeDefinition<T>(themeDefinitions: ThemeDefinition<T>): T;
export function useThemeDefinition<T>(themeDefinitions: readonly ThemeDefinition<T>[]): T[];
export function useThemeDefinition<T>(
  themeDefinitions: ThemeDefinition<T> | readonly ThemeDefinition<T>[],
) {
  const definitions = ([] as ThemeDefinition<T>[]).concat(themeDefinitions);
  const theme = useTheme();

  const processedDefinitions = definitions.map((definition) => definition(theme));

  return Array.isArray(themeDefinitions) ? processedDefinitions : processedDefinitions[0];
}
